import { useLang } from '@/i18n';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import J from './components/J';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import R from './components/R';

export default function IndexDynamic() {
    const { t } = useLang('loadshedding');
    const [isClient, setIsClient] = useState(false);

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_btn1'), link: '#load-shedding-D' },
            { text: t('secC_btn2'), link: '#load-shedding-E' },
            { text: t('secC_btn3'), link: '#load-shedding-F' },
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C tags={obj.items} />
            <F />
            <E />
            <D />
            <J />
            <O />
            <P />
            <Q />
            <R />
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
